import { Attribute } from '@angular/compiler';
import { TransAddTrustFields } from '../../../shared/models/TransAddTrustFields';
import { InternalTransferVerifyRequest } from './InternalTransferVerifyRequest';
import { RelatedCustomer } from './RelatedCustomer';
import { Attributes } from '../../../shared/models/JsonApiWrap';

export class InternalTransferAcknowledgeListRequest
  implements Attributes<InternalTransferAcknowledgeRequest>
{
  attributes: InternalTransferAcknowledgeRequest;
  type: string;
  id: string;
}

export class InternalTransferAcknowledgeRequest extends InternalTransferVerifyRequest {
    eauthSelected: boolean = false;
    isSubmitAndCreateSLOA: boolean = false;
    customerList: RelatedCustomer[] = [];
    customerListSloa: RelatedCustomer[] = [];
    stockHandlerId: number = 0;
    isUseSloa: boolean = false;
    acknowledgementConsentDateTime: string = '';
    trustFieldsRequestInfo: TransAddTrustFields | null;
    draftId: string;
    isThirdParty: boolean = false;

    public constructor(init?: Partial<InternalTransferAcknowledgeRequest>) {
        super();
        Object.assign(this, init);
    }
}
